import React from 'react';
import {
  string, shape, arrayOf, func, number, bool
} from 'prop-types';
import { Button, RadioGroup, Radio } from '@thd-olt-component-react/core-ui';
import { DELIMITER } from './Constants';
import * as styles from './quotes.module.scss';

export const Quotes = ({
  quoteList,
  selectQuote,
  selectedQuote,
  showLoadMore,
  quotesPageSize,
  setQuotesPageSize
}) => {

  const handleLoadMore = () => {
    setQuotesPageSize(quotesPageSize + 20);
  };

  return (
    <div className={styles.quoteList}>
      <RadioGroup className={styles.quoteList__group}>
        {quoteList.map((quote, i) => (
          <Radio
            key={quote.name}
            id={quote.quoteId}
            onChange={selectQuote}
            value={`${quote.quoteId}${DELIMITER}${quote.userId}${DELIMITER}${quote.name}`}
            label={quote.name}
            checked={selectedQuote.quoteId === quote.quoteId}
            padding
          />
        ))}
      </RadioGroup>
      {showLoadMore && (
        <Button className={styles.quoteList__button} onClick={handleLoadMore} link> Load More...</Button>
      )}
    </div>
  );
};

Quotes.propTypes = {
  quoteList: arrayOf(shape({
    name: string,
  })),
  selectQuote: func.isRequired,
  selectedQuote: shape({
    quoteId: string.isRequired,
    quoteName: string.isRequired,
    userId: string.isRequired
  }).isRequired,
  showLoadMore: bool.isRequired,
  quotesPageSize: number.isRequired,
  setQuotesPageSize: func.isRequired
};

Quotes.defaultProps = {
  quoteList: [],
};
